import './BillingSummaryBox.scss';
import { FunctionComponent } from 'react';
import { Link } from '@lmig/lmds-react-link';
import { IconPolicy } from '@lmig/lmds-react-icons';

interface IBillingSummaryBox {
  totalBillingDocumentCount: number;
  sumTotalMinimumDueAmount: number;
  billingPaymentServicesLink: string;
}
export const BillingSummaryBox: FunctionComponent<any> = (props?: IBillingSummaryBox) => {
  return (
    <>
      <div
        data-cs-mask // IMPORTANT: DO NOT REMOVE data-cs-mask attribute, this ensures the PII data is masked correctly for session replay
        className="billing-summary-container"
      >
        <div className="billing-summary-icon-container">
          <div className="billing-summary-icon-box">
            <IconPolicy color="blue" size="24" />
          </div>
        </div>
        <div className="billing-summary-container-body">
          <div className="billing-summary-dollar-amount">
            {props?.sumTotalMinimumDueAmount?.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })}
          </div>
          <div className="billing-summary-text">
            <div>{`Pending non-pay cancel (${props?.totalBillingDocumentCount} policies)`}</div>
          </div>
          {props?.billingPaymentServicesLink && props.billingPaymentServicesLink.length > 0 ? (
            <div>
              <Link href={props.billingPaymentServicesLink}>Manage billing and payments</Link>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};
